import React from 'react';
import './_styles.scss';
import { UserPermissions } from '../../../../definitions';
import { securityService } from '../../../../_global/services';

interface BanksCardProps {
  data?: any;
}

export default function BanksCard({ data }: BanksCardProps) {
  const { name } = data;
  return securityService.checkRoleAccess(UserPermissions.viewUsers) ? (
    <div className='user-card'>
      <div className='full-name'>{`${name}`}</div>
    </div>
  ) : (
    <div></div>
  );
}
